
//沙特资源按钮
const VrmSaAuthBtn = {
    // 预约
    AppointmentAdd: "vrm-sa.AppointmentAdd",
    AppointmentEdit: "vrm-sa.AppointmentEdit",
    AppointmentView: "vrm-sa.AppointmentView",
    AppointmentTransfertoMaintenance: "vrm-sa.AppointmentTransfertoMaintenance",
    AppointmentPrint: "vrm-sa.AppointmentPrint",
    AppointmentCancel: "vrm-sa.AppointmentCancel",
    AppointmentDetailsSave: "vrm-sa.AppointmentDetailsSave",
    AppointmentDetailsCancel: "vrm-sa.AppointmentDetailsCancel",
    AppointmentDetailsRefresh: "vrm-sa.AppointmentDetailsRefresh",
    // 维修开单
    MaintenanceAdd: "vrm-sa.MaintenanceAdd",
    MaintenanceEdit: "vrm-sa.MaintenanceEdit",
    MaintenanceView: "vrm-sa.MaintenanceView",
    MaintenancePrint: "vrm-sa.MaintenancePrint",
    MaintenanceCancel: "vrm-sa.MaintenanceCancel",
    MaintenancePayment: "vrm-sa.MaintenancePayment",
    MaintenanceStockout: "vrm-sa.MaintenanceStockout",
    MaintenanceDetailsSave: "vrm-sa.MaintenanceDetailsSave",
    MaintenanceDetailsCancel: "vrm-sa.MaintenanceDetailsCancel",
    MaintenanceDetailsRefresh: "vrm-sa.MaintenanceDetailsRefresh",
    // 配件销售
    MaterialSalesAdd: "vrm-sa.MaterialSalesAdd",
    MaterialSalesEdit: "vrm-sa.MaterialSalesEdit",
    MaterialSalesView: "vrm-sa.MaterialSalesView",
    MaterialSalesPrint: "vrm-sa.MaterialSalesPrint",
    MaterialSalesCancel: "vrm-sa.MaterialSalesCancel",
    MaterialSalesPayment: "vrm-sa.MaterialSalesPayment",
    MaterialSalesStockout: "vrm-sa.MaterialSalesStockout",
    MaterialSalesDetailsSave: "vrm-sa.MaterialSalesDetailsSave",
    MaterialSalesDetailsCancel: "vrm-sa.MaterialSalesDetailsCancel",
    MaterialSalesDetailsRefresh: "vrm-sa.MaterialSalesDetailsRefresh",
    // 配件退货
    SalesReturnAdd: "vrm-sa.SalesReturnAdd",
    SalesReturnEdit: "vrm-sa.SalesReturnEdit",
    SalesReturnView: "vrm-sa.SalesReturnView",
    SalesReturnPrint: "vrm-sa.SalesReturnPrint",
    SalesReturnCancel: "vrm-sa.SalesReturnCancel",
    SalesReturnPayment: "vrm-sa.SalesReturnPayment",
    SalesReturnStockin: "vrm-sa.SalesReturnStockin",
    SalesReturnDetailsSave: "vrm-sa.SalesReturnDetailsSave",
    SalesReturnDetailsCancel: "vrm-sa.SalesReturnDetailsCancel",
    SalesReturnDetailsRefresh: "vrm-sa.SalesReturnDetailsRefresh",
    // 采购入库
    PurchaseStockInAdd: "vrm-sa.PurchaseStockInAdd",
    PurchaseStockInEdit: "vrm-sa.PurchaseStockInEdit",
    PurchaseStockInView: "vrm-sa.PurchaseStockInView",
    PurchaseStockInPrint: "vrm-sa.PurchaseStockInPrint",
    PurchaseStockInCancel: "vrm-sa.PurchaseStockInCancel",
    PurchaseStockInPayment: "vrm-sa.PurchaseStockInPayment",
    PurchaseStockInStockin: "vrm-sa.PurchaseStockInStockin",
    PurchaseStockInDetailsSave: "vrm-sa.PurchaseStockInDetailsSave",
    PurchaseStockInDetailsCancel: "vrm-sa.PurchaseStockInDetailsCancel",
    PurchaseStockInDetailsRefresh: "vrm-sa.PurchaseStockInDetailsRefresh",
    // 采购退货
    PurchaseReturnAdd: "vrm-sa.PurchaseReturnAdd",
    PurchaseReturnEdit: "vrm-sa.PurchaseReturnEdit",
    PurchaseReturnView: "vrm-sa.PurchaseReturnView",
    PurchaseReturnPrint: "vrm-sa.PurchaseReturnPrint",
    PurchaseReturnCancel: "vrm-sa.PurchaseReturnCancel",
    PurchaseReturnPayment: "vrm-sa.PurchaseReturnPayment",
    PurchaseReturnStockout: "vrm-sa.PurchaseReturnStockout",
    PurchaseReturnDetailsSave: "vrm-sa.PurchaseReturnDetailsSave",
    PurchaseReturnDetailsCancel: "vrm-sa.PurchaseReturnDetailsCancel",
    PurchaseReturnDetailsRefresh: "vrm-sa.PurchaseReturnDetailsRefresh",
    // 库存统计
    InventoryStatisticsView: "vrm-sa.InventoryStatisticsView",
    // 库存盘点
    StocktakingAdd: "vrm-sa.StocktakingAdd",
    StocktakingEdit: "vrm-sa.StocktakingEdit",
    StocktakingView: "vrm-sa.StocktakingView",
    StocktakingCancel: "vrm-sa.StocktakingCancel",
    StocktakingDetailsSave: "vrm-sa.StocktakingDetailsSave",
    StocktakingDetailsCancel: "vrm-sa.StocktakingDetailsCancel",
    StocktakingDetailsInventoryToComplete: "vrm-sa.StocktakingDetailsInventoryToComplete",
    //出库单据
    StockOutView: "vrm-sa.StockOutView",
    StockOutDetailsReturn: "vrm-sa.StockOutDetailsReturn",
    //入库单据
    StockInView: "vrm-sa.StockInView",
    StockInDetailsReturn: "vrm-sa.StockInDetailsReturn",
    //供应商
    SupplierManagementAdd: "vrm-sa.SupplierManagementAdd",
    SupplierManagementEdit: "vrm-sa.SupplierManagementEdit",
    SupplierManagementView: "vrm-sa.SupplierManagementView",
    SupplierManagementImport: "vrm-sa.SupplierManagementImport",
    SupplierManagementDownloadTheTemplate: "vrm-sa.SupplierManagementDownloadTheTemplate",
    SupplierManagementDetailsSave: "vrm-sa.SupplierManagementDetailsSave",
    SupplierManagementDetailsCancel: "vrm-sa.SupplierManagementDetailsCancel",
    SupplierManagementDetailsReplacement: "vrm-sa.SupplierManagementDetailsReplacement",
    //配件档案
    MaterialManagementAdd: "vrm-sa.MaterialManagementAdd",
    MaterialManagementEdit: "vrm-sa.MaterialManagementEdit",
    MaterialManagementView: "vrm-sa.MaterialManagementView",
    MaterialManagementImport: "vrm-sa.MaterialManagementImport",
    MaterialManagementDownloadTheTemplate: "vrm-sa.MaterialManagementDownloadTheTemplate",
    MaterialManagementDetailsSave: "vrm-sa.MaterialManagementDetailsSave",
    MaterialManagementDetailsCancel: "vrm-sa.MaterialManagementDetailsCancel",
    MaterialManagementDetailsReplacement: "vrm-sa.MaterialManagementDetailsReplacement",
    //仓库管理
    WarehouseSettingsAdd: "vrm-sa.WarehouseSettingsAdd",
    WarehouseSettingsEdit: "vrm-sa.WarehouseSettingsEdit",
    WarehouseSettingsView: "vrm-sa.WarehouseSettingsView",
    WarehouseSettingsImport: "vrm-sa.WarehouseSettingsImport",
    WarehouseSettingsDetailsSave: "vrm-sa.WarehouseSettingsDetailsSave",
    WarehouseSettingsDetailsCancel: "vrm-sa.WarehouseSettingsDetailsCancel",
    // 数据字典
    DataDictionaryIncreaseaAtALowerLevel: "vrm-sa.DataDictionaryIncreaseaAtALowerLevel",
    DataDictionaryIncreaseAtTheSameLevel: "vrm-sa.DataDictionaryIncreaseAtTheSameLevel",
    DataDictionaryDetailsSave: "vrm-sa.DataDictionaryDetailsSave",
    DataDictionaryDetailsCancel: "vrm-sa.DataDictionaryDetailsCancel",
    // 客户档案
    CustomerManagementAdd: "vrm-sa.CustomerManagementAdd",
    CustomerManagementEdit: "vrm-sa.CustomerManagementEdit",
    CustomerManagementView: "vrm-sa.CustomerManagementView",
    CustomerManagementImport: "vrm-sa.CustomerManagementImport",
    CustomerManagementDownloadTheTemplate: "vrm-sa.CustomerManagementDownloadTheTemplate",
    CustomerManagementSubordinateVehicle: "vrm-sa.CustomerManagementSubordinateVehicle",
    CustomerManagementDetailsSave: "vrm-sa.CustomerManagementDetailsSave",
    CustomerManagementDetailsCancel: "vrm-sa.CustomerManagementDetailsCancel",
    CustomerManagementDetailsReplacement: "vrm-sa.CustomerManagementDetailsReplacement",
    // 车辆档案
    VehicleManagementAdd: "vrm-sa.VehicleManagementAdd",
    VehicleManagementEdit: "vrm-sa.VehicleManagementEdit",
    VehicleManagementView: "vrm-sa.VehicleManagementView",
    VehicleManagementImport: "vrm-sa.VehicleManagementImport",
    VehicleManagementDownloadTheTemplate: "vrm-sa.VehicleManagementDownloadTheTemplate",
    VehicleManagementReturningCustomers: "vrm-sa.VehicleManagementReturningCustomers",
    VehicleManagementDetailsSave: "vrm-sa.VehicleManagementDetailsSave",
    VehicleManagementDetailsCancel: "vrm-sa.VehicleManagementDetailsCancel",
    VehicleManagementDetailsReplacement: "vrm-sa.VehicleManagementDetailsReplacement",
    //维修项目档案
    MaintenanceItemsAdd: "vrm-sa.MaintenanceItemsAdd",
    MaintenanceItemsEdit: "vrm-sa.MaintenanceItemsEdit",
    MaintenanceItemsView: "vrm-sa.MaintenanceItemsView",
    MaintenanceItemsImport: "vrm-sa.MaintenanceItemsImport",
    MaintenanceItemsDownloadTheTemplate: "vrm-sa.MaintenanceItemsDownloadTheTemplate",
    MaintenanceItemsDetailsSave: "vrm-sa.MaintenanceItemsDetailsSave",
    MaintenanceItemsDetailsCancel: "vrm-sa.MaintenanceItemsDetailsCancel",
    MaintenanceItemsDetailsReplacement: "vrm-sa.MaintenanceItemsDetailsReplacement",
    //维修技师档案
    TechnicianManagementAdd: "vrm-sa.TechnicianManagementAdd",
    TechnicianManagementEdit: "vrm-sa.TechnicianManagementEdit",
    TechnicianManagementView: "vrm-sa.TechnicianManagementView",
    TechnicianManagementDetailsSave: "vrm-sa.TechnicianManagementDetailsSave",
    TechnicianManagementDetailsCancel: "vrm-sa.TechnicianManagementDetailsCancel",
    TechnicianManagementDetailsReplacement: "vrm-sa.TechnicianManagementDetailsReplacement",
}
//尼日利亚资源按钮
const VrmNgaAuthBtn = {
    // 预约
    AppointmentAdd: "AppointmentAdd",
    AppointmentEdit: "AppointmentEdit",
    AppointmentView: "AppointmentView",
    AppointmentTransfertoMaintenance: "AppointmentTransfertoMaintenance",
    AppointmentPrint: "AppointmentPrint",
    AppointmentCancel: "AppointmentCancel",
    AppointmentDetailsSave: "AppointmentDetailsSave",
    AppointmentDetailsCancel: "AppointmentDetailsCancel",
    AppointmentDetailsRefresh: "AppointmentDetailsRefresh",
    // 维修开单
    MaintenanceAdd: "MaintenanceAdd",
    MaintenanceEdit: "MaintenanceEdit",
    MaintenanceView: "MaintenanceView",
    MaintenancePrint: "MaintenancePrint",
    MaintenanceCancel: "MaintenanceCancel",
    MaintenancePayment: "MaintenancePayment",
    MaintenanceStockout: "MaintenanceStockout",
    MaintenanceDetailsSave: "MaintenanceDetailsSave",
    MaintenanceDetailsCancel: "MaintenanceDetailsCancel",
    MaintenanceDetailsRefresh: "MaintenanceDetailsRefresh",
    MaintenanceDetailsApproval: "MaintenanceDetailsApproval",
    MaintenanceDetailsPassed: "MaintenanceDetailsPassed",

    // 销售订单
    SalesOrderAdd: "SalesOrderAdd",
    SalesOrderEdit: "SalesOrderEdit",
    SalesOrderView: "SalesOrderView",
    SalesOrderPrint: "SalesOrderPrint",
    SalesOrderCancel: "SalesOrderCancel",
    SalesOrderTransfer: "SalesOrderTransfer",
    SalesOrderDetailsSave: "SalesOrderDetailsSave",
    SalesOrderDetailsCancel: "SalesOrderDetailsCancel",
    SalesOrderDetailsRefresh: "SalesOrderDetailsRefresh",

    // 配件销售
    MaterialSalesAdd: "MaterialSalesAdd",
    MaterialSalesEdit: "MaterialSalesEdit",
    MaterialSalesView: "MaterialSalesView",
    MaterialSalesPrint: "MaterialSalesPrint",
    MaterialSalesCancel: "MaterialSalesCancel",
    MaterialSalesPayment: "MaterialSalesPayment",
    MaterialSalesStockout: "MaterialSalesStockout",
    MaterialSalesDetailsSave: "MaterialSalesDetailsSave",
    MaterialSalesDetailsCancel: "MaterialSalesDetailsCancel",
    MaterialSalesDetailsRefresh: "MaterialSalesDetailsRefresh",
    // 配件退货
    SalesReturnAdd: "SalesReturnAdd",
    SalesReturnEdit: "SalesReturnEdit",
    SalesReturnView: "SalesReturnView",
    SalesReturnPrint: "SalesReturnPrint",
    SalesReturnCancel: "SalesReturnCancel",
    SalesReturnPayment: "SalesReturnPayment",
    SalesReturnStockin: "SalesReturnStockin",
    SalesReturnDetailsSave: "SalesReturnDetailsSave",
    SalesReturnDetailsCancel: "SalesReturnDetailsCancel",
    SalesReturnDetailsRefresh: "SalesReturnDetailsRefresh",
    // 采购入库
    PurchaseStockInAdd: "PurchaseStockInAdd",
    PurchaseStockInEdit: "PurchaseStockInEdit",
    PurchaseStockInView: "PurchaseStockInView",
    PurchaseStockInPrint: "PurchaseStockInPrint",
    PurchaseStockInCancel: "PurchaseStockInCancel",
    PurchaseStockInPayment: "PurchaseStockInPayment",
    PurchaseStockInStockin: "PurchaseStockInStockin",
    PurchaseStockInDetailsSave: "PurchaseStockInDetailsSave",
    PurchaseStockInDetailsCancel: "PurchaseStockInDetailsCancel",
    PurchaseStockInDetailsRefresh: "PurchaseStockInDetailsRefresh",
    // 采购退货
    PurchaseReturnAdd: "PurchaseReturnAdd",
    PurchaseReturnEdit: "PurchaseReturnEdit",
    PurchaseReturnView: "PurchaseReturnView",
    PurchaseReturnPrint: "PurchaseReturnPrint",
    PurchaseReturnCancel: "PurchaseReturnCancel",
    PurchaseReturnPayment: "PurchaseReturnPayment",
    PurchaseReturnStockout: "PurchaseReturnStockout",
    PurchaseReturnDetailsSave: "PurchaseReturnDetailsSave",
    PurchaseReturnDetailsCancel: "PurchaseReturnDetailsCancel",
    PurchaseReturnDetailsRefresh: "PurchaseReturnDetailsRefresh",
    // 库存统计
    InventoryStatisticsView: "InventoryStatisticsView",
    // 库存盘点
    StocktakingAdd: "StocktakingAdd",
    StocktakingEdit: "StocktakingEdit",
    StocktakingView: "StocktakingView",
    StocktakingCancel: "StocktakingCancel",
    StocktakingDetailsSave: "StocktakingDetailsSave",
    StocktakingDetailsCancel: "StocktakingDetailsCancel",
    StocktakingDetailsInventoryToComplete: "StocktakingDetailsInventoryToComplete",
    //出库单据
    StockOutView: "StockOutView",
    StockOutDetailsReturn: "StockOutDetailsReturn",
    //入库单据
    StockInView: "StockInView",
    StockInDetailsReturn: "StockInDetailsReturn",
    //供应商
    SupplierManagementAdd: "SupplierManagementAdd",
    SupplierManagementEdit: "SupplierManagementEdit",
    SupplierManagementView: "SupplierManagementView",
    SupplierManagementImport: "SupplierManagementImport",
    SupplierManagementDownloadTheTemplate: "SupplierManagementDownloadTheTemplate",
    SupplierManagementDetailsSave: "SupplierManagementDetailsSave",
    SupplierManagementDetailsCancel: "SupplierManagementDetailsCancel",
    SupplierManagementDetailsReplacement: "SupplierManagementDetailsReplacement",
    //配件档案
    MaterialManagementAdd: "MaterialManagementAdd",
    MaterialManagementEdit: "MaterialManagementEdit",
    MaterialManagementView: "MaterialManagementView",
    MaterialManagementImport: "MaterialManagementImport",
    MaterialManagementDownloadTheTemplate: "MaterialManagementDownloadTheTemplate",
    MaterialManagementDetailsSave: "MaterialManagementDetailsSave",
    MaterialManagementDetailsCancel: "MaterialManagementDetailsCancel",
    MaterialManagementDetailsReplacement: "MaterialManagementDetailsReplacement",
    //仓库管理
    WarehouseSettingsAdd: "WarehouseSettingsAdd",
    WarehouseSettingsEdit: "WarehouseSettingsEdit",
    WarehouseSettingsView: "WarehouseSettingsView",
    WarehouseSettingsImport: "WarehouseSettingsImport",
    WarehouseSettingsDetailsSave: "WarehouseSettingsDetailsSave",
    WarehouseSettingsDetailsCancel: "WarehouseSettingsDetailsCancel",
    // 数据字典
    DataDictionaryIncreaseaAtALowerLevel: "DataDictionaryIncreaseaAtALowerLevel",
    DataDictionaryIncreaseAtTheSameLevel: "DataDictionaryIncreaseAtTheSameLevel",
    DataDictionaryDetailsSave: "DataDictionaryDetailsSave",
    DataDictionaryDetailsCancel: "DataDictionaryDetailsCancel",
    // 客户档案
    CustomerManagementAdd: "CustomerManagementAdd",
    CustomerManagementEdit: "CustomerManagementEdit",
    CustomerManagementView: "CustomerManagementView",
    CustomerManagementImport: "CustomerManagementImport",
    CustomerManagementDownloadTheTemplate: "CustomerManagementDownloadTheTemplate",
    CustomerManagementSubordinateVehicle: "CustomerManagementSubordinateVehicle",
    CustomerManagementDetailsSave: "CustomerManagementDetailsSave",
    CustomerManagementDetailsCancel: "CustomerManagementDetailsCancel",
    CustomerManagementDetailsReplacement: "CustomerManagementDetailsReplacement",
    // 车辆档案
    VehicleManagementAdd: "VehicleManagementAdd",
    VehicleManagementEdit: "VehicleManagementEdit",
    VehicleManagementView: "VehicleManagementView",
    VehicleManagementImport: "VehicleManagementImport",
    VehicleManagementDownloadTheTemplate: "VehicleManagementDownloadTheTemplate",
    VehicleManagementReturningCustomers: "VehicleManagementReturningCustomers",
    VehicleManagementDetailsSave: "VehicleManagementDetailsSave",
    VehicleManagementDetailsCancel: "VehicleManagementDetailsCancel",
    VehicleManagementDetailsReplacement: "VehicleManagementDetailsReplacement",
    //维修项目档案
    MaintenanceItemsAdd: "MaintenanceItemsAdd",
    MaintenanceItemsEdit: "MaintenanceItemsEdit",
    MaintenanceItemsView: "MaintenanceItemsView",
    MaintenanceItemsImport: "MaintenanceItemsImport",
    MaintenanceItemsDownloadTheTemplate: "MaintenanceItemsDownloadTheTemplate",
    MaintenanceItemsDetailsSave: "MaintenanceItemsDetailsSave",
    MaintenanceItemsDetailsCancel: "MaintenanceItemsDetailsCancel",
    MaintenanceItemsDetailsReplacement: "MaintenanceItemsDetailsReplacement",
    //维修技师档案
    TechnicianManagementAdd: "TechnicianManagementAdd",
    TechnicianManagementEdit: "TechnicianManagementEdit",
    TechnicianManagementView: "TechnicianManagementView",
    TechnicianManagementDetailsSave: "TechnicianManagementDetailsSave",
    TechnicianManagementDetailsCancel: "TechnicianManagementDetailsCancel",
    TechnicianManagementDetailsReplacement: "TechnicianManagementDetailsReplacement",
}
export const ResourcesAuthBtn:any  = {
    "vrm-sa":VrmSaAuthBtn,
    "vrm-nga-yh":VrmNgaAuthBtn,
    "vrm-int":{}
}